import { pluralForm } from "@utils";

import dayjs from "dayjs";
import React, { useState, useEffect } from "react";

import "./style.scss";

const Timer = ({ endDate }) => {
    const [timerSeconds, setTimerSeconds] = useState(0);
    let nw = dayjs(endDate, "YYYY-MM-DDTHH:mm:ss").add(5, "day");
    let st = dayjs();
    const dateOut = nw.diff(st, "second");
    const outSecond = dateOut;

    useEffect(() => {
        if (!isNaN(outSecond)) {
            setTimerSeconds(outSecond);
        }
    }, [outSecond]);

    useEffect(() => {
        let timer = null;

        if (outSecond !== 0 && outSecond > 0) {
            timer = setTimeout(() => setTimerSeconds(timerSeconds - 1), 1000);
        }
        return () => {
            if (timer) clearTimeout(timer);
        };
    });

    const outTimer = timeLeft(timerSeconds);

    const outDays = outSecond < 0 ? "0" : outTimer.day >= 10 ? outTimer.day : "" + outTimer.day;
    const outHours = outSecond < 0 ? "00" : outTimer.hours >= 10 ? outTimer.hours : "0" + outTimer.hours;
    const outMinutes = outSecond < 0 ? "00" : outTimer.minutes >= 10 ? outTimer.minutes : "0" + outTimer.minutes;
    const outSeconds = outSecond < 0 ? "00" : outTimer.seconds >= 10 ? outTimer.seconds : "0" + outTimer.seconds;

    let arrDays = outDays.toString().split("");
    let arrHours = outHours.toString().split("");
    let arrMinutes = outMinutes.toString().split("");
    let arrSeconnds = outSeconds.toString().split("");

    return (
        <div className="timer-wrap_lazy_v2">
            <ArrTime arr={arrDays} />
            &nbsp;
            <span className="timer-wrap__split">{`д${pluralForm(arrDays.join(""), ["ень", "ня", "ней"])} `}</span> &nbsp;
            <ArrTime arr={arrHours} />
            <span className="timer-wrap__split">:</span>
            <ArrTime arr={arrMinutes} />
            <span className="timer-wrap__split">:</span>
            <ArrTime arr={arrSeconnds} text={`сек.`} />
        </div>
    );
};

const ArrTime = ({ arr }) => {
    return arr.map((it, idx) => (
        <span key={idx} className="block__number_text">
            {it}
        </span>
    ));
};

const timeLeft = (seconds) => {
    return {
        day: Math.floor(seconds / (3600 * 24)),
        hours: Math.floor((seconds / (60 * 60)) % 24),
        minutes: Math.floor((seconds / 60) % 60),
        seconds: Math.floor(seconds % 60),
    };
};

const areEqual = (prevProps, nextProps) => {
    const prev = prevProps.endDate;
    const next = nextProps.endDate;

    return prev !== next;
};

export default React.memo(Timer, areEqual);
